// src/components/profile/roi/FinancialVsStrategic.jsx
import React from 'react';
import { DollarSign, Target } from 'lucide-react';

export default function FinancialVsStrategic({ financial, strategic }) {
  const formatPercent = (value) => {
    if (!value || isNaN(value)) return '0%';
    return `${Math.round(value)}%`;
  };
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
      {/* Financial Analysis */}
      <div className="border-2 border-green-500 rounded-lg p-6 bg-green-50">
        <div className="flex items-center gap-2 mb-4">
          <DollarSign className="w-6 h-6 text-green-600" />
          <h4 className="font-semibold text-green-900">Financial Analysis</h4>
        </div>
        
        <div className="text-4xl font-bold text-green-600 mb-2">
          {formatPercent(financial.roiPct)} ROI
        </div>
        
        <div className="text-sm text-gray-700 mb-4">
          Payback in {financial.paybackMonths || 'N/A'} months
        </div>
        
        <div className="pt-4 border-t border-green-300">
          <div className="text-sm text-gray-700">Recommendation:</div>
          <div className={`font-bold mt-1 ${
            financial.recommendation?.status === 'proceed' ? 'text-green-600' :
            financial.recommendation?.status === 'caution' ? 'text-yellow-600' :
            'text-red-600'
          }`}>
            {financial.recommendation?.status === 'proceed' ? 'Strong Proceed' :
             financial.recommendation?.status === 'caution' ? 'Proceed with Caution' :
             'Reconsider'}
          </div>
        </div>
      </div>
      
      {/* Strategic Analysis */}
      <div className="border-2 border-blue-500 rounded-lg p-6 bg-blue-50">
        <div className="flex items-center gap-2 mb-4">
          <Target className="w-6 h-6 text-blue-600" />
          <h4 className="font-semibold text-blue-900">Strategic Analysis</h4>
        </div>
        
        <div className="text-4xl font-bold text-blue-600 mb-2">
          {strategic.label || 'Low Priority'}
        </div>
        
        <div className="text-sm text-gray-700 mb-4">
          Score: {strategic.score}/100 • Rank: #{strategic.rank}
        </div>
        
        <div className="pt-4 border-t border-blue-300">
          <div className="text-sm text-gray-700">Based on:</div>
          <ul className="text-sm text-gray-600 mt-1 space-y-1">
            <li>• Implementation complexity</li>
            <li>• Organizational readiness</li>
            <li>• Strategic alignment</li>
          </ul>
        </div>
      </div>
    </div>
  );
}